// Chuyển số thành chữ tiếng Việt
export const numberToVietnameseText = (number: number): string => {
  if (!Number.isFinite(number) || number < 0) return "";
  if (number === 0) return "Không đồng";

  const units = ["", "nghìn", "triệu", "tỷ"];
  const digitWords = [
    "không",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ];

  const readThreeDigits = (num: number): string => {
    let result = "";
    const hundred = Math.floor(num / 100);
    const ten = Math.floor((num % 100) / 10);
    const unit = num % 10;

    if (hundred > 0) {
      result += digitWords[hundred] + " trăm";
      if (ten === 0 && unit > 0) result += " lẻ";
    }

    if (ten > 1) {
      result += (result ? " " : "") + digitWords[ten] + " mươi";
      if (unit === 1) result += " mốt";
      else if (unit > 0) result += " " + digitWords[unit];
    } else if (ten === 1) {
      result += (result ? " " : "") + "mười";
      if (unit > 0) result += " " + digitWords[unit];
    } else if (unit > 0 && hundred > 0) {
      result += " " + digitWords[unit];
    } else if (unit > 0) {
      result += (result ? " " : "") + digitWords[unit];
    }

    return result.trim();
  };

  let numStr = Math.floor(number).toString();
  const result: string[] = [];
  let unitIndex = 0;

  while (numStr.length > 0) {
    const threeDigits = numStr.slice(-3);
    const num = parseInt(threeDigits, 10);

    if (num > 0) {
      const text = readThreeDigits(num);
      result.unshift(text + (unitIndex > 0 ? " " + units[unitIndex] : ""));
    }

    numStr = numStr.slice(0, -3);
    unitIndex++;
  }

  let finalText = result.join(" ");
  finalText = finalText.charAt(0).toUpperCase() + finalText.slice(1);
  return finalText + " đồng chẵn";
};
